import { money } from "../lib/util";

export const GROUP_COLORS = { housing: "#C89662", utilities: "#6FA8DC", food: "#6FBF8E", transportation: "#E0B354", shopping: "#C27BA0",
  sparrow: "#E8916B", credit_card: "#8E7CC3", other: "#9AA0A6" };

export function SpendDonut({ groups = [], total = 0, size = 200, stroke = 18, label = true, caption = "SPENT THIS MONTH", testid }) {
  const r = (size - stroke) / 2, c = 2 * Math.PI * r, mid = size / 2;
  let off = 0;
  const segs = groups.filter((g) => g.amount_cents > 0).map((g) => {
    const len = (g.amount_cents / (total || 1)) * c, s = { k: g.key, len, off };
    off += len;
    return s;
  });
  return (
    <svg width={size} height={size} viewBox={`0 0 ${size} ${size}`} data-testid={testid}>
      <circle cx={mid} cy={mid} r={r} fill="none" stroke="var(--selected)" strokeWidth={stroke} />
      {segs.map((s) => <circle key={s.k} cx={mid} cy={mid} r={r} fill="none" stroke={GROUP_COLORS[s.k] || GROUP_COLORS.other} strokeWidth={stroke}
        strokeDasharray={`${Math.max(s.len - (segs.length > 1 ? 2 : 0), 0)} ${c}`} strokeDashoffset={-s.off} transform={`rotate(-90 ${mid} ${mid})`}
        style={{ transition: "stroke-dasharray 600ms ease" }} data-testid={`${testid}-seg-${s.k}`} />)}
      {label && <>
        <text x={mid} y={mid - 2} textAnchor="middle" fill="var(--text)" fontSize={size / 8.5} fontWeight="600" data-testid={`${testid}-total`}>{money(total)}</text>
        <text x={mid} y={mid + size / 10} textAnchor="middle" fill="var(--text2)" fontSize={Math.max(size / 22, 8)} letterSpacing="2">{caption}</text>
      </>}
    </svg>
  );
}

export function SpendLegend({ groups = [], testid = "spend-legend" }) {
  if (!groups.length) return <p className="text-sm text-oh-text2" data-testid={`${testid}-empty`}>No spending recorded yet.</p>;
  return (
    <div className="space-y-2 text-sm w-full" data-testid={testid}>
      {groups.map((g) => (
        <div key={g.key} className="flex items-center gap-2" data-testid={`${testid}-${g.key}`}>
          <span className="w-2.5 h-2.5 rounded-sm shrink-0" style={{ background: GROUP_COLORS[g.key] || GROUP_COLORS.other }} />
          <span className="flex-1">{g.label}</span>
          <span className="text-oh-text2 text-xs tabular-nums w-12 text-right">{g.pct}%</span>
          <b className="tabular-nums w-24 text-right">{money(g.amount_cents)}</b>
        </div>))}
    </div>
  );
}
